export const instantSearchBetHouseMarkUp = {
  render: function(data) {
    return data.map(item => `
      <article class="instant-search-bethouse" id="bet-house-${item.id}" style="background-color: ${item.bar_color};">
        <img src="${item.logo_image}" alt="${item.title.rendered} - ${item.card_subtitle}" class="instant-search-bethouse__img">
        <span class="instant-search-bethouse__title">${item.card_subtitle}</span>

        <div class="instant-search-bethouse__link-wrp">
          <a href="${item.link_button_bet}" class="instant-search-bethouse__link">Apostar</a>
          <a href="${item.link}" class="instant-search-bethouse__link-btn">Leia o review</a>
        </div>
      </article>
    `)
  },
  renderMobile: function(data) {
    return data.map(item => `
      <article class="instant-search-bethouse" id="bet-house-${item.id}" style="background-color: ${item.bar_color};">
        <img src="${item.logo_image}" alt="${item.title.rendered} - ${item.card_subtitle}" class="instant-search-bethouse__img">
        <span class="instant-search-bethouse__title">${item.card_subtitle}</span>
        <a href="${item.link_button_bet}" class="instant-search-bethouse__link">Apostar</a>
        <a href="${item.link}" class="instant-search-bethouse__link-btn">Leia o review</a>
      </article>
    `)
  }
}
